import { SIZE_TYPE } from '../renderMixin'

export default {
  backgroundColor: '#ffffff',
  textColor: '#909399',
  activeColor: '#303133',
  hoverColor: '#303133',
  btnColor: '#000000',
  menus: [
    {
      label: '首页',
      path: '/index',
      isInner: true,
      openInNewWindow: false
    }
  ],
  size: {
    width: {
      type: SIZE_TYPE.AUTO,
      fixed: null,
      percentage: null
    },
    height: {
      type: SIZE_TYPE.AUTO,
      fixed: null,
      percentage: null
    }
  }
}
